
<template>
  <!--健康码-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="openLogId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_photo" slot-scope="{row}">
        <a-button @click="showPicture(row.photo)" type="link">查看</a-button>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'healthCode',
  mixins: [fetchSelect],
  data () {
    const healthCode = [
      { value: '00', label: '绿码' },
      { value: '01', label: '黄码' },
      { value: '10', label: '红码' },
      { value: '无', label: '无' }
    ];
    const memberType = [
      { value: '1', label: '住户' }, { value: '2', label: '管家' }
    ];
    const verifyResult = [
      { value: '1', label: '通过' }, { value: '0', label: '不通过' }
    ];
    const healthStatusObj = {
      '00': { color: 'success', txt: '绿码' },
      '01': { color: 'warn', txt: '黄码' },
      10: { color: 'danger', txt: '红码' }
    };
    return {
      searchList: [
        { props: ['createDate'], placeholder: ['识别时间', '识别时间'], options: [], inputType: 'dateTimePick' },
        { props: ['communityId'], placeholder: '所在小区', options: [], inputType: 'select' },
        { props: ['verificationStatus'], placeholder: '核验结果', options: verifyResult, inputType: 'select' },
        { props: ['temp'], placeholder: '测温结果', options: [], inputType: 'input' }, // 36.5-37.2
        { props: ['healthyStatus'], placeholder: '健康码状态', options: healthCode, inputType: 'select' },
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['memberType'], placeholder: '身份', options: memberType, inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [],
      columns: [
        { title: '所在小区', dataIndex: 'communityName', align: '', width: '', ellipsis: true },
        { title: '通行门', dataIndex: 'positionName', align: '', width: '' },
        { title: '设备名称', dataIndex: 'deviceName', align: '', width: '', ellipsis: true },
        {
          title: '身份',
          dataIndex: 'memberType',
          align: '',
          width: '60px',
          customCell: (row) => ({ domProps: { innerHTML: row.memberType === 1 ? '住户' : '管家' } })
        },
        { title: '手机号', dataIndex: 'mobile', align: '', width: '120px' },
        {
          title: '体温',
          dataIndex: 'temp',
          align: '',
          width: '60px',
          customCell: row => {
            return {
              domProps: { innerHTML: row.temp ? row.temp : '无' }
            };
          }
        },
        {
          title: '健康码状态',
          dataIndex: 'healthyStatus',
          align: '',
          width: '110px',
          customCell: row => {
            return {
              domProps: { innerHTML: healthStatusObj[row.healthyStatus] ? healthStatusObj[row.healthyStatus].txt : '无' },
              class: healthStatusObj[row.healthyStatus] ? healthStatusObj[row.healthyStatus].color : '',
              style: { fontWeight: 400 }
            };
          }
        },
        {
          title: '核验结果',
          dataIndex: 'verificationStatus',
          align: '',
          width: '',
          customCell: row => ({ domProps: { innerHTML: row.verificationStatus === 1 ? '通过' : '不通过' } })
        },
        { title: '证件号', dataIndex: 'desensitizeCardId', align: '', width: '150px' },
        { title: '姓名', dataIndex: 'desensitizeName', align: '', width: '' },
        { title: '14天行程记录', dataIndex: 'xcgj', align: '', width: '', ellipsis: true },
        { title: '抓拍', dataIndex: 'photo', align: '', width: '60px', scopedSlots: { customRender: 'photo' } },
        { title: '识别时间', dataIndex: 'openTime', align: '', width: '170px' }
      ],
      dataSource: [],
      searchParams: {
        createDate: undefined,
        communityId: undefined,
        verificationStatus: undefined,
        temp: undefined,
        healthyStatus: undefined,
        mobile: undefined,
        memberType: undefined
      },
      listApi: {
        url: '/health/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(1, 'searchList', 1);
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
